(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bdf-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('bdf-language-form')) return;
  const returnTo = form.querySelector('input[name="return_to"]');
  if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
});
  } catch(e) { console.error(e); }
})();

})();
